import React, { useState, useRef } from 'react'
import { View, TextInput, TouchableOpacity, Platform, Dimensions } from 'react-native'
import PropTypes from 'prop-types'

import { VFText, Icon } from '@vfgroup-oneplatform/foundation/Components'

import { withTheme, getThemeImages as getGroupThemedImages } from '@vfgroup-oneplatform/foundation/Components/Themes'

import OfferDescription from '../OfferDescription'
import OfferContent from '../OfferContent'
import CollapsibleItem from '../Collapsible/CollapsibleItem/CollapsibleItem'
import Card from '../Card'
import HorizontalLine from '../HorizontalLine'
import VFButton from '../VFButton/VFButton'
import TotalCost from '../TotalCost'

import { Images, getThemeImages } from '../../Themes'

import styles from './Summary.Styles'

function Summary({
  currentIndex,
  changeCurrentIndex,
  selectedOffer,
  selectedSimNumber,
  addressInfo,
  confirmLoading,
  theme,
  setAddressInfo,
  scrollRef,
}) {

  const [open, setOpened] = useState(false)
  const [editAddress, setEditAddress] = useState(false)

  const [addressPosition, setAddressPosition] = useState(0)

  const groupThemedImages = getGroupThemedImages(theme.name)

  const themedImages = getThemeImages(theme.name)

  const addressInput = useRef()

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <View>
        <View>
          <VFText
            i18nKey="acquisition_summary_step_title"
            style={styles.stepTitle}
          />
          <VFText
            i18nKey="acquisition_summary_step_subtitle"
            style={styles.stepDesc(theme)}
          />
        </View>

        <Card contentContainerStyle={styles.container} style={styles.simCardStyle} type="main">
          <View style={styles.simCardContainer}>
            <Icon
              name={groupThemedImages.ic_sim}
              type="image"
              size={40}
              resizeMode="contain"
            />
            <View style={styles.text}>
              <VFText
                i18nKey="acquisition_id_step_card_title"
                style={styles.stepDesc(theme)}
              />
              <VFText
                i18nKey="acquisition_id_step_card_subtitle"
                style={styles.title(theme)}
              />
            </View>
          </View>
          <HorizontalLine style={styles.line(theme)} />
          <View style={styles.selectedSimContainer(theme)}>
            <Icon
              name={Images.simCard}
              size={80}
              type="image"
            />
            <View style={styles.text}>
              <VFText
                i18nKey="acquisition_summary_step_selected_sim_title"
                style={styles.cardTitle}
              />
              <VFText
                i18nKey="acquisition_summary_step_selected_sim_subtitle"
                style={styles.stepDesc(theme)}
              />
              {!!selectedSimNumber && <VFText
                i18nKey={selectedSimNumber}
                style={styles.title(theme)}
              />}

            </View>
          </View>
        </Card>

        <View style={styles.addressContainer}>

          <VFText
            i18nKey="acquisition_summary_step_delivery_subtitle"
            style={styles.stepDesc(theme)}
          />

          <View style={styles.deliveryContainer(theme)} onLayout={ev => setAddressPosition(ev?.nativeEvent?.layout?.y + ev?.nativeEvent?.layout?.height)}>
            <Icon
              name={groupThemedImages.icLocation}
              size={30}
              type="image"
            />

            {editAddress ? <TextInput
              ref={addressInput}
              value={addressInfo?.address}
              style={[styles.inputContainer, styles.address(theme)]}
              onBlur={() => setEditAddress(false)}
              autoFocus={editAddress}
              onChangeText={(text) => setAddressInfo(prev => { return { ...prev, address: text } })}
              returnKeyType="done"
            /> : <View style={styles.inputContainer} >
              <VFText
                i18nKey={addressInfo?.address}
                style={styles.address(theme)}
                numberOfLines={1}
              />
            </View>}

            {!editAddress && <TouchableOpacity
              onPress={() => {
                scrollRef?.current?.scrollTo({ x: 0, y: addressPosition, animated: true })
                addressInput?.current?.focus()
                setEditAddress(true)
              }}
            >
              <Icon
                name={themedImages.edit}
                size={25}
                type="image"
              />
            </TouchableOpacity>}
            {/* <VFText
                     i18nKey={addressInfo?.address}
                     style={styles.address(theme)}
                     numberOfLines={1}
                   /> */}
          </View>

        </View>

        <View>
          <VFText
            i18nKey="acquisition_summary_step_offer_title"
            style={styles.stepTitle}
          />
          <VFText
            i18nKey="acquisition_summary_step_offer_subtitle"
            style={styles.stepDesc(theme)}
          />
        </View>
        <Card
          style={[styles.offerCardStyle, styles.cardStyle]}
          contentContainerStyle={styles.cardContentContainer}
        >
          <CollapsibleItem
            type="primary"
            title={selectedOffer?.title || ''}
            desc={() => (
              <OfferDescription
                price={selectedOffer?.price || ''}
                period={selectedOffer?.isMonthly ? 'acquisition_monthly' : ''}
                priceReduction={selectedOffer?.priceReduction || ''}
              />
            )}
            content={<OfferContent offer={selectedOffer} summary />}
            isOpend={open}
            onPress={() => setOpened(!open)}
            onItemPress={() => setOpened(!open)}
            icon={themedImages.offerDefaultIcon || selectedOffer?.icon}
            titleStyle={styles.titleOfferStyle}
            theme={theme}
          />
        </Card>

        <TotalCost
          offer={selectedOffer}
          renderButton={() => {
            return (
              <VFButton
                title="acquisition_done"
                onPress={() => changeCurrentIndex(currentIndex + 1)}
                isLoading={confirmLoading}
                loadingTitle="acquisition_loading_button"
              />
            )
          }}
        />
      </View>
    )
  }

  return (
    <View>
      <View>
        <VFText
          i18nKey="acquisition_summary_step_title"
          style={styles.stepTitle}
        />
        <VFText
          i18nKey="acquisition_summary_step_subtitle"
          style={styles.stepDesc(theme)}
        />
      </View>

      <Card contentContainerStyle={styles.container} style={styles.simCardStyle} type="main">
        <View style={styles.simCardContainer}>
          <Icon
            name={themedImages.new_sim}
            type="image"
            size={40}
            resizeMode="contain"
          />
          <View style={styles.text}>
            <VFText
              i18nKey="acquisition_id_step_card_title"
              style={styles.stepDesc(theme)}
            />
            <VFText
              i18nKey="acquisition_id_step_card_subtitle"
              style={styles.title(theme)}
            />
          </View>
        </View>
        <HorizontalLine style={styles.line(theme)} />
        <View style={styles.selectedSimContainer(theme)}>
          <Icon
            name={Images.big_sim}
            size={80}
            type="image"
          />
          <View style={styles.text}>
            <VFText
              i18nKey="acquisition_summary_step_selected_sim_title"
              style={styles.cardTitle}
            />
            <VFText
              i18nKey="acquisition_summary_step_selected_sim_subtitle"
              style={styles.stepDesc(theme)}
            />
            {!!selectedSimNumber && <VFText
              i18nKey={selectedSimNumber}
              style={styles.title(theme)}
            />}

          </View>
        </View>
      </Card>
      {/* 
      <View style={styles.addressContainer}>

        <VFText
          i18nKey="acquisition_summary_step_delivery_subtitle"
          style={styles.stepDesc(theme)}
        />

        <View style={styles.deliveryContainer(theme)} onLayout={ev => setAddressPosition(ev?.nativeEvent?.layout?.y + ev?.nativeEvent?.layout?.height)}>
          <Icon
            name={themedImages.bundle || selectedOffer?.icon}
            size={36}
            type="image"
          />
          <View style={styles.textDelivery}>
            <VFText i18nKey={addressInfo?.address} style={[styles.inputContainer, styles.address(theme)]}/>
            <OfferDescription
              price={selectedOffer?.price || ''}
              period={selectedOffer?.isMonthly ? 'acquisition_monthly' : ''}
              priceReduction={selectedOffer?.priceReduction || ''}
            />
          </View>
        </View>

      </View> */}


      <View style={styles.addressContainer}>

        <VFText
          i18nKey="acquisition_summary_step_delivery_subtitle"
          style={styles.stepDesc(theme)}
        />

        <View style={styles.deliveryContainer(theme)} onLayout={ev => setAddressPosition(ev?.nativeEvent?.layout?.y + ev?.nativeEvent?.layout?.height)}>
          <Icon
            name={themedImages.bundle || selectedOffer?.icon}
            size={36}
            type="image"
          />

          {editAddress ? <TextInput
            ref={addressInput}
            value={addressInfo?.address}
            style={[styles.inputContainer, styles.address(theme)]}
            onBlur={() => setEditAddress(false)}
            autoFocus={editAddress}
            onChangeText={(text) => setAddressInfo(prev => { return { ...prev, address: text } })}
            returnKeyType="done"
          /> : <View style={styles.inputContainer} >
            <VFText
              i18nKey={addressInfo?.address}
              style={styles.address(theme)}
              numberOfLines={1}
            />
          </View>}

          {!editAddress && <TouchableOpacity
            onPress={() => {
              scrollRef?.current?.scrollTo({ x: 0, y: addressPosition, animated: true })
              addressInput?.current?.focus()
              setEditAddress(true)
            }}
          >
            <Icon
              name={themedImages.edit}
              size={25}
              type="image"
            />
          </TouchableOpacity>}
        </View>

      </View>



      <View>
        <VFText
          i18nKey="acquisition_summary_step_offer_title"
          style={styles.stepTitle}
        />
        <VFText
          i18nKey="acquisition_summary_step_offer_subtitle"
          style={styles.stepDesc(theme)}
        />
      </View>
      <Card
        style={[styles.offerCardStyle, styles.cardStyle]}
        contentContainerStyle={styles.cardContentContainer}
      >
        <CollapsibleItem
          type="primary"
          title={selectedOffer?.title || ''}
          desc={() => (
            <OfferDescription
              price={selectedOffer?.price || ''}
              period={selectedOffer?.isMonthly ? 'acquisition_monthly' : ''}
              priceReduction={selectedOffer?.priceReduction || ''}
            />
          )}
          content={<OfferContent offer={selectedOffer} summary />}
          isOpend={open}
          onPress={() => setOpened(!open)}
          onItemPress={() => setOpened(!open)}
          icon={themedImages.bundle || selectedOffer?.icon}
          titleStyle={styles.titleOfferStyle}
          theme={theme}
        />
      </Card>

      <TotalCost
        offer={selectedOffer}
        renderButton={() => {
          return (
            <VFButton
              title="acquisition_done"
              onPress={() => changeCurrentIndex(currentIndex + 1)}
              isLoading={confirmLoading}
              loadingTitle="acquisition_loading_button"
            />
          )
        }}
      />
    </View>
  )
}

Summary.propTypes = {
  currentIndex: PropTypes.number,
  changeCurrentIndex: PropTypes.func,
  selectedOffer: PropTypes.object,
  selectedSimNumber: PropTypes.string,
  addressInfo: PropTypes.object,
  confirmLoading: PropTypes.bool,
  setAddressInfo: PropTypes.func,
}

export default withTheme(Summary)
